const EMBED_PROVIDERS = ['yt', 'ytnc', 'vi']

// GrapesJS rebuilds the iframe URL only when the video id or provider changes.
// Autoplay, loop, controls, related videos, and modest branding live on the
// component and never reach the saved src unless we write them ourselves.
const EMBED_PROPS = ['loop', 'autoplay', 'controls', 'color', 'rel', 'modestbranding', 'list']

function isEmbedProvider(component) {
  return EMBED_PROVIDERS.includes(component.get('provider'))
}

function embedSrc(component) {
  const provider = component.get('provider')

  if (provider === 'vi') return component.getVimeoSrc()
  if (provider === 'ytnc') return component.getYoutubeNoCookieSrc()

  return component.getYoutubeSrc()
}

/**
 * Keeps YouTube and Vimeo embed URLs in sync with the video settings.
 *
 * @param {object} editor
 */
export default function videoEmbedPlugin(editor) {
  const baseModel = editor.DomComponents.getType('video').model

  editor.DomComponents.addType('video', {
    model: {
      init() {
        queueMicrotask(() => {
          if (!this.em || typeof this.get !== 'function') return

          const events = EMBED_PROPS.map(prop => `change:${prop}`).join(' ')

          this.on(events, this.syncVideoEmbed)
          this.on('change:src', this.syncVideoSrcAttribute)
          this.syncVideoEmbed()
        })
      },

      /**
       * Export uses this, so the iframe src stays correct even when the stored
       * src attribute is still the URL from before the last toggle.
       */
      getSrcResult(opt = {}) {
        const videoId = this.get('videoId')

        if (!opt.fallback && isEmbedProvider(this) && videoId) {
          return embedSrc(this)
        }

        return baseModel.prototype.getSrcResult.call(this, opt)
      },

      syncVideoEmbed() {
        if (isEmbedProvider(this) && this.get('videoId') && typeof this.updateSrc === 'function') {
          this.updateSrc()
        }

        this.syncVideoSrcAttribute()
      },

      syncVideoSrcAttribute() {
        const src = this.getSrcResult()

        if (!src || this.getAttributes().src === src) return

        this.addAttributes({ src })
      },
    },
  })
}
